import {defineStore} from "pinia";
import axios from "axios";
import {VersionedEntityStatus} from "@/store/model/VersionedEntityStatus";
import {Proposal} from "@/store/model/Proposal";
import {ProposalLogbookItem} from "@/store/model/LogbookItem";

export const proposalStore = defineStore('proposalStore', {
    state: () => ({
        proposalInfo: null,
        proposalNotAvailable: false,
        proposalOpinionsOfOthers: [],
        lifeCycleModalState: false,
        actualProposalModalState: false,
        paramActualPropInfo: null,
        actualProposalContent: null,
        proposersModalState: false,
        proposalLogbookModalState: false,
        proposalLogbookData: null,
        proposalArguments: [],

        //Create proposal
        searchPropString: '',
        searchingState: false,
        existingProposals: [],
        createPropFormViewState: false,

        proposalNeedUpdateModalState: false,

        selectedActualType: { name: 'Add text', value: 'HTML_TEXT' },
        actualProposalTextVal: '',
        actualProposalFile: null,
    }),
    getters: {
        latestProposalVersionId() {
            const latestProposalVersion = this.proposalInfo.versions.find((v) => v.status === VersionedEntityStatus.CURRENT);
            return latestProposalVersion ? latestProposalVersion.id : null;
        },
        draftProposalVersionId() {
            const draftProposalVersion = this.proposalInfo.versions.find((v) => v.status === VersionedEntityStatus.DRAFT);
            return draftProposalVersion ? draftProposalVersion.id : null;
        },
        actualProposalInfo() {
            return this.paramActualPropInfo || this.proposalInfo.actualProposal;
        },
    },
    actions: {
        async getProposalInfoByIssueNumber(proposalIssueNumber, proposalVersion) {
            let dataIsLoaded = [];
            let proposalList = [];

            dataIsLoaded.push(
                axios.get(`/api/proposals?issueNumbers=${proposalIssueNumber}&status=ACTIVE&page=0&size=10`).then((resp)=> {
                    if (resp.data.content.length > 0) {
                        proposalList = resp.data.content;
                    } else {
                        return axios.get(`/api/proposals?issueNumbers=${proposalIssueNumber}&status=CLOSED&page=0&size=10`).then((res)=> {
                            proposalList = res.data.content;
                        });
                    }
                })
            );

            await Promise.all(dataIsLoaded).then(()=> {
                let proposalId = null;
                if (proposalList.length > 0) {
                    proposalId = proposalList[proposalList.length - 1].id;
                }

                if (proposalId) {
                    return this.getProposalInfo(proposalId).then(()=> {
                        if (proposalVersion) {
                            const versionProposal = this.proposalInfo.versions.find((proposal)=> proposal.version === proposalVersion);
                            if (versionProposal) {
                                return this.getProposalInfo(versionProposal.id);
                            }
                        }
                    });
                } else {
                    this.proposalNotAvailable = true;
                }
            });
        },
        getProposalInfoAction(proposalId) {
            return axios.get(`/api/proposals/${proposalId}`);
        },
        getProposalInfo(proposalId) {
            return axios.get(`/api/proposals/${proposalId}`)
                .then((res) => {
                    this.proposalInfo = new Proposal(res.data);
                })
                .catch((error) => {
                    const errorStatus = error.response.status;
                    this.proposalNotAvailable = (errorStatus === 400 || errorStatus === 404);
                }) ;
        },
        getActualTextContent(documentId) {
            return axios.get(`/api/cms/${documentId}/text`)
                .then((res) => {
                    this.actualProposalContent = res.data;
                })
                .catch(error => console.log(error));
        },
        getActualDocContent(docHash) {
            return axios.get(`/api/attachment/${docHash}/download`)
                .then((res) => {
                    this.actualProposalContent = res.data;
                })
                .catch(error => console.log(error));
        },
        getProposalOpinionsOfOthersAction(proposalId) {
            return axios.get(`/api/opinion/others?proposalId=${proposalId}`, {
                data: {},
            }).then((res) => {
                this.proposalOpinionsOfOthers = res.data;
            });
        },
        toggleLifeCycleModal() {
            this.lifeCycleModalState = !this.lifeCycleModalState;
        },
        openActualProposalModal(paramActualPropInfo) {
            if (paramActualPropInfo) {
                this.paramActualPropInfo = paramActualPropInfo;
            }

            this.actualProposalModalState = true;
        },
        closeActualProposalModal() {
            this.actualProposalModalState = false;
            this.paramActualPropInfo = null;
        },
        toggleProposersModal() {
            this.proposersModalState = !this.proposersModalState;
        },
        setProposalArguments(argumentsList) {
            this.proposalArguments = argumentsList;
        },
        //Create proposal
        setSearchPropString(val) {
            this.searchPropString = val;
        },
        searchExistingProposals() {
            this.searchingState = true;
            return axios.get(`/api/proposals?&title=` + this.searchPropString)
                .then((res) => {
                    this.existingProposals = res.data.content;
                    this.searchingState = false;
                })
                .catch(error => console.log(error));
        },
        openCreatePropFormView() {
            this.createPropFormViewState = true;
        },
        closeCreatePropFormView() {
            this.createPropFormViewState = false;
        },

        //Proposal logbook
        getProposalLogbookDataAction(proposalId) {
            return axios.get(`/api/proposals/${proposalId}/logbook`).then((resp)=> {
                this.proposalLogbookData = resp.data.map(i => new ProposalLogbookItem(i)).toSorted((a, b) => b.version - a.version);
            });
        },
        toggleProposalLogbookModalState() {
            this.proposalLogbookModalState = !this.proposalLogbookModalState;
        }
    }
})